/* eslint-disable no-unused-vars  */

import 'jquery';

//activating animations
document.addEventListener('DOMContentLoaded', function() {
  var body = document.querySelector('body');
  body.classList.remove('preload');
});

var already_loaded = false;

$(window).on('load', function(){ 
  already_loaded = true;
});

$(function() {

  $(document).on('click','[data-toggle-nav]', function() {
    $('.navigation').toggleClass('navigation--open');

    $('.hamburger').toggleClass('hamburger--open');
    position_menu_text();
  });

  if(already_loaded) {
    position_menu_text();
  } else {
    $(window).on('load', function(){
      position_menu_text();
    });
  }
  
  $( window ).resize(function() {
    position_menu_text();
  });

  function position_menu_text() {
    var width = $('.navigation__item').outerWidth();
    var height = $('.navigation__item').outerHeight();

    $('.navigation__text').css({
      top: height / 2,
      left: width / 2,
    })
  }


  $( window ).on('scroll', function() {

    if($(window).scrollTop() > $('.teijin-banner').height()) {
      $('.header').addClass('animated');
      $('.logo').addClass('animated');
      $('.banner__title').addClass('banner__title--fade');
    } else {
      $('.header').removeClass('animated');
      $('.logo').removeClass('animated');
      $('.banner__title').removeClass('banner__title--fade');
    }
  });

  set_banner_size();
  $( window ).on('resize', function() {
    set_banner_size();
  });

  function set_banner_size() {
    var viewportHeight = $(window).height();
    var teijinHeight = $('.teijin-banner').outerHeight();
    var headerHeight = $('.header').outerHeight();

    var banner_size = viewportHeight  - teijinHeight;

    if($(window).width() < 750 ) {
      banner_size = banner_size - headerHeight;
    }

    $('.banner').css({ height: banner_size });
  }

  //duration = videoDuration.duration

  // if($('.splash__video').length > 0) {

  //   setInterval(function(){
  //     var duration = $('.splash__video')[0].duration;
  //     var currentTime = $('.splash__video')[0].currentTime;

  //     if(duration - currentTime < 2) {
  //       close_video();
  //     }
  //   }, 1000);
  // } 


  // $('.splash__video').on('ended', function(){
  //   close_video();
  // });

  // $('.splash__skip').on('click', function(){
  //   close_video();
  // });

  if($('.splash').is(':visible')) {
    $('.logo').addClass('logo--front');
  }

  $('[data-animate-onload').addClass('animated');

  // function close_video() {
  //   $('.splash').removeClass('splash--shown');
  //    createCookie('yuami_splash', 1, 0);
  //   $('.logo').removeClass('logo--front');

  //   $('[data-animate-onskip]').addClass('animated');
  // }


  $('.banner__video').on('play', function(){
    $('[data-animate-onstart').addClass('animated');
  });

  if( $('.banner__video').length > 0) {

    var currentTime = $('.banner__video')[0].currentTime;

    if(currentTime >0) {
      $('[data-animate-onstart]').addClass('animated');
    }
  }



  /*************************************************************************** 
                              News detail sticky
  ************************************************************************** */

    $(window).on('scroll', function() {
      $('[data-stick-wrap]').each(function(){
        // var top = $('[data-stick]').position().top;
        // var bottom = top + $('[data-stick]').height();
  
        var container_top = $('[data-stick-wrap]').offset().top;
        var container_bottom = $('[data-stick-wrap]').offset().top + $('[data-stick-wrap]').height();
  
        // var win = $(window).scrollTop() + $('.header').height() + 140;
        // var trig = container_bottom ;
        // //console.log('win ' + win + 'trig ' + trig);

        var difference = window.innerHeight - $('[data-stick]').height() - 65;
        
        if($(window).scrollTop() < (container_top - 65)) {
          $('[data-stick]').removeClass('news-detail__sidebar--fixed');
        }else if($(window).scrollTop()  + window.innerHeight > (container_bottom + difference )) {
          $('[data-stick]').removeClass('news-detail__sidebar--fixed');
          $('[data-stick]').addClass('news-detail__sidebar--bottom');
        }else {
          $('[data-stick]').addClass('news-detail__sidebar--fixed');
          $('[data-stick]').removeClass('news-detail__sidebar--bottom');
        }
      });
    });
  
});

 ////////////////////////////////// Animation triggers /////////////////////////////////////////


 var items_to_animate = [].slice.call(document.querySelectorAll('[data-animate]'));

if ('IntersectionObserver' in window) {
  var configAnimation = {
    // If the element gets within 10px in the Y axis, start the animation.
    rootMargin: '0px 0px -200px 0px',
    threshold: 0.01,
  };

  let animation_observer = new IntersectionObserver(function on_intersection(entries){
    entries.forEach(function(entry) {

      //we check the type of animation to see if it should only triggered once or not
      var animation_type = entry.target.dataset.animate;

      if (entry.isIntersecting) {
        //element is in the view so we start the animation
        entry.target.classList.add('animated');

        //If the animation should be done only once, remove the observer
        if(animation_type == 'once')
        {
          animation_observer.unobserve(entry.target);
        }
      }else{

        if( animation_type != 'once'){
          //If the animation have to be triggered again
          entry.target.classList.remove('animated');
        }
      }

    });
  }, configAnimation);

  items_to_animate.forEach(function(item_to_animate) {
    animation_observer.observe(item_to_animate);
  });
}else{
  //fallback
  items_to_animate.forEach(function (item_to_animate){
    item_to_animate.classList.add('animated');
  })
}

// function createCookie(name,value,days) {

//   var expires = ''

//   if (days) {
//       var date = new Date();
//       date.setTime(date.getTime()+(days*24*60*60*1000));
//       expires = '; expires='+date.toGMTString();
//   }
//   document.cookie = name+'='+value+expires+'; path=/'; 
// }


// WEBPACK FOOTER //
// ./scripts/main.js